<template>
  <div>
    <NavBar />
    <div class="container main-container">
      <OrderList
        v-bind:orders="$store.state.laundryOrdersObserved"
        v-bind:type="'OBSERVED'"
        v-bind:mutable="true"
        v-bind:acceptText="'Confirmar'"
        v-bind:rejectText="'Cancelar'"
        v-bind:onAcceptDialog="this.confirm"
        v-bind:onRejectDialog="this.cancel"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderList from "../components/OrderList";
import NavBar from "../components/NavBar";

export default {
  name: "ordersObserved",
  created() {
    this.getOrders();
  },
  components: {
    OrderList,
    NavBar
  },
  methods: {
    getOrders: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      this.$http
        .post(url + "orders?state=rejected_reception", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          let orders = result.body.result.orders;
          this.$store.commit("updateLaundryOrders", orders);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    },

    confirm: function(event, order) {
      event.stopPropagation()
      var self = this;
      this.$dialog
        .confirm("Esta seguro de aceptar los cambios?", {
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(function(dialog) {
          let url = self.$store.state.connection.url;
          let endpoint = url + `orders/${order.id}/accept_changes`;

          self.$http
            .post(endpoint, {})
            .then(response => {
              if (response.body.result) {
                let updatedOrder = response.body.result
                self.$store.commit("updateLaundryOrders", updatedOrder);
                self.$router.push('home');
              }
            })
            .catch(err => {});
        })
        .catch(function() {});
    },
    cancel: function(event, order) {
      event.stopPropagation()
      var self = this;
      this.$dialog
        .confirm("Desea rechazar la correcion de este pedido?", {
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(function(dialog) {
          let url = self.$store.state.connection.url;
          let endpoint = url + `orders/${order.id}/reject_changes`;

          self.$http
            .post(endpoint, {})
            .then(response => {
              if (response.body.result) {
                let updatedOrder = response.body.result
                self.$store.commit("updateLaundryOrders", updatedOrder);
                self.$router.push('home');
              }
            })
            .catch(err => {});
        })
        .catch(function() {});
    }
  },
  data: function() {
    return {
      filteredOrders: () => {
        let results = {}
        for (var order in this.$store.state.orders) {
            if (this.$store.state.orders[order].status == 'rejected_reception')
              results[order] = this.$store.state.orders[order]
        }
        if (JSON.stringify(results) === JSON.stringify({}))
          return undefined
        return results
      }
    };
  }
};
</script>

<style></style>
